import PropTypes from 'prop-types'
import { SearchPageQuery } from '@layouts/search'

const SearchPage = ({ query }) => {
  return (
    <SearchPageQuery {...query} />
  )
}

SearchPage.getInitialProps = async ({ query }) => ({ query })

SearchPage.propTypes = {
  query: PropTypes.object,
}

export default SearchPage
